<template>
    <div>
        <div class="main-content">
            <div class="page-content">
            <div class="container">
                <div class="page-links">
                    <router-link to="/climbing/camps" class="page-links__item is-active">Camps & Heights</router-link>
                    <router-link to="/climbing/distance" class="page-links__item">Distance & Time</router-link>
                    <router-link to="/climbing/temperature" class="page-links__item">Temperature</router-link>
                    <router-link to="/climbing/moon" class="page-links__item">Moon Phases</router-link>
                </div>
                 <div class="lds-ring" v-if="!isLoad"><div></div><div></div><div></div><div></div></div>
                <section class="kilimanjaro-settings kilimanjaro-settings--camp" v-if="isLoad">
                <div class="page-title">
                    <h2>Camps and Heights</h2>
                </div>
                <form action="javascript:void(0" class="kilimanjaro-settings__form">

                    <div class="form-control-group form-control-group_mounts" v-if="mountains.find(item => item.active)"><span class="form-control-label">Mount</span>
                         <div :class="['select-wrapper select-wrapper', {'is-active' : mountSelect}]" @click="mountSelect = !mountSelect">
                            <div class="select-trigger"><span class="select-trigger__name">{{mountains.find(item => item.active).title}}</span><span class="select-trigger__icon">
                                <svg width="1em" height="1em" class="icon icon-chevron ">
                                    <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                                </svg></span></div>
                            <div class="select-body">
                                <div class="select-inner js-scrollbar">
                                <div 
                                    v-for="item in mountains"
                                    :key="item.id"
                                    :class="['select-option', { 'is-selected': item.active }]"
                                    @click="mountains = mountains.map(mount => ({...mount, active: mount.id === item.id}))"><span class="select-option__name">{{item.title}}</span></div>
                                </div>
                            </div>
                            </div>
                    </div>

                    <div class="kilimanjaro-settings__table">
                    <div class="section-table-wrap">
                        <div class="section-table section-table--camp">
                        <div class="section-table__head">
                            <div class="col col-camp-name"><span>Camp Name(EN)</span></div>
                            <div class="col col-camp-name"><span>Camp Name(RU)</span></div>
                            <div class="col col-camp-name"><span>Camp Name(DE)</span></div>
                            <div class="col col-camp-name"><span>Camp Name(ES)</span></div>
                            <div class="col col-camp-name"><span>Camp Name(FR)</span></div>
                            <div class="col col-camp-name"><span>Camp Name(PT)</span></div>
                            <div class="col col-camp-name"><span>Camp Name(NL)</span></div>
                            <div class="col col-meters"><span>Meters</span></div>
                            <div class="col col-feet"><span>Feet</span></div>
                        </div>
                        <div class="section-table__body">
                            <div class="section-table__row" v-for="item in camps" :key="item.id">
                            <div class="col col-camp-name">
                                <div class="form-control-group">
                                <div class="form-control-wrap">
                                    <input type="text" placeholder="Camp Name" v-model="item.names.EN" @input="item.name = $event.target.value.replace(/[^A-Za-z0-9- ]/g, '');isEdit = true" @focus="$event.target.parentElement.classList.remove('is-error')" class="form-control form-control-name"/>
                                </div>
                                </div>
                            </div>
                            <div class="col col-camp-name">
                                <div class="form-control-group">
                                <div class="form-control-wrap">
                                    <input type="text" placeholder="Camp Name" v-model="item.names.RU" @input="item.name = $event.target.value.replace(/[^A-Za-z0-9- ]/g, '');isEdit = true" @focus="$event.target.parentElement.classList.remove('is-error')" class="form-control form-control-name"/>
                                </div>
                                </div>
                            </div>
                            <div class="col col-camp-name">
                                <div class="form-control-group">
                                <div class="form-control-wrap">
                                    <input type="text" placeholder="Camp Name" v-model="item.names.DE" @input="item.name = $event.target.value.replace(/[^A-Za-z0-9- ]/g, '');isEdit = true" @focus="$event.target.parentElement.classList.remove('is-error')" class="form-control form-control-name"/>
                                </div>
                                </div>
                            </div>
                              <div class="col col-camp-name">
                                <div class="form-control-group">
                                <div class="form-control-wrap">
                                    <input type="text" placeholder="Camp Name" v-model="item.names.ES" @input="item.name = $event.target.value.replace(/[^A-Za-z0-9- ]/g, '');isEdit = true" @focus="$event.target.parentElement.classList.remove('is-error')" class="form-control form-control-name"/>
                                </div>
                                </div>
                            </div>
                              <div class="col col-camp-name">
                                <div class="form-control-group">
                                <div class="form-control-wrap">
                                    <input type="text" placeholder="Camp Name" v-model="item.names.FR" @input="item.name = $event.target.value.replace(/[^A-Za-z0-9- ]/g, '');isEdit = true" @focus="$event.target.parentElement.classList.remove('is-error')" class="form-control form-control-name"/>
                                </div>
                                </div>
                            </div>
                              <div class="col col-camp-name">
                                <div class="form-control-group">
                                <div class="form-control-wrap">
                                    <input type="text" placeholder="Camp Name" v-model="item.names.PT" @input="item.name = $event.target.value.replace(/[^A-Za-z0-9- ]/g, '');isEdit = true" @focus="$event.target.parentElement.classList.remove('is-error')" class="form-control form-control-name"/>
                                </div>
                                </div>
                            </div>
                              <div class="col col-camp-name">
                                <div class="form-control-group">
                                <div class="form-control-wrap">
                                    <input type="text" placeholder="Camp Name" v-model="item.names.NL" @input="item.name = $event.target.value.replace(/[^A-Za-z0-9- ]/g, '');isEdit = true" @focus="$event.target.parentElement.classList.remove('is-error')" class="form-control form-control-name"/>
                                </div>
                                </div>
                            </div>
                            <div class="col col-meters">
                                <div class="form-control-group">
                                <div class="form-control-wrap">
                                    <input type="text" placeholder="Meters" @input="item.meters = $event.target.value > 1 ? Math.round($event.target.value.replace(/\D/g, '')) : $event.target.value.replace(/\D/g, '');calcFeets();isEdit = true" v-model="item.meters" @focus="$event.target.parentElement.classList.remove('is-error')" class="form-control form-control-meters"/>
                                </div>
                                </div>
                            </div>
                            <div class="col col-feet">
                                <div class="form-control-group">
                                <div class="form-control-wrap">
                                    <input type="number" disabled placeholder="Feet" v-model="item.feet" class="form-control "/>
                                </div>
                                </div>
                            </div>
                            <div class="col col-action">
                                <button type="button" class="btn btn--remove" @click="$emit('deleteModalHandler', {
                                    entity: 'Camp',
                                    name: item.name,
                                    handler: deleteCamp,
                                    id: item.id
                                })">
                                <svg width="1em" height="1em" class="icon icon-close ">
                                    <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
                                </svg>
                                </button>
                            </div>
                            </div>
                        </div>
                        </div>
                    </div>
                    </div>
                    <div class="kilimanjaro-settings__add" @click="createCamp">
                    <button type="button" class="btn btn--rounded"><span>Add Campsite</span></button>
                    </div>
                    <div class="kilimanjaro-settings__submit" @click="saveCamps">
                    <button type="submit" class="btn btn--green"><span>Save</span></button>
                    </div>
                </form>
                </section>
            </div>
            </div>
        </div>
    </div>
</template>

<script>

    import { 
        getCamps,
        updateCamps,
        getMountains
    } from '@/utilites/api'

    export default {
        data(){
            return { 
                camps: [],
                mountains: [],
                mountSelect: false,
                isLoad: false,
                isEdit: false
            }
        },
        beforeRouteLeave(to, from, next){
			if(this.isEdit){
				this.$emit('notLeaveHandler')
			}
			next()
		},
        props: ['user'],
        beforeCreate(){
            document.title = 'Climbing / Camps & Heights'
        },
        mounted(){
            document.title = 'Climbing / Camps & Heights'
            getMountains(this.user.access_token)
            .then(res => {
                this.mountains = res.map((item, index) => ({...item, active: index === 0}))
            })
            window.addEventListener('click', event => {
                if(!event.target.closest('.select-wrapper')){
                    this.mountSelect = false
                }
            })
        },
        methods: {
            checkErrors(){
                let error = false
                    document.querySelectorAll('.form-control-name').forEach(elem => {
                        if(elem.value.trim().length <= 0){
                            elem.parentElement.classList.add('is-error')
                            error = true
                        }
                    })
                    document.querySelectorAll('.form-control-meters').forEach(elem => {
                        if(elem.value.trim().length <= 0 || elem.value<= 0){
                            elem.parentElement.classList.add('is-error')
                            error = true
                        }
                    })
                return error
            },
            deleteCamp(id){
                this.camps = this.camps.filter(item => !(item.id === id))
                this.isEdit = true
            },
            createCamp(){
                this.camps = this.camps.concat({
                    id: Date.now(),
                    names: { EN : '', RU: '', DE: '', ES: '', FR: '', PT: '', NL: '' },
                    meters: '',
                    feet: '',
                    isNew: true,
                    errors: {}
                })
                this.isEdit = true
            },
            updateData(id){
                getCamps(this.user.access_token, id)
                .then(res => {
                    this.camps = res.map(item => ({...item, errors: {}}))
                    this.calcFeets()
                    this.isLoad = true
                })
                .catch(() => {
                    this.isLoad = true
                    this.camps = []
                })
            },
            saveCamps(){
                if(!this.checkErrors()){
                    updateCamps(this.user.access_token, this.camps.map(item => item.isNew ? { names: item.names, meters: item.meters, feet: item.feet } : item), this.mountains.find(item => item.active).id)
                    .then(() => {
                        this.$emit('confirmed')
                        this.isEdit = false
                        this.updateData(this.mountains.find(item => item.active).id)
                    })
                }
            },
            calcFeets(){
                this.camps = this.camps.map(item => ({...item, feet: Math.round(+item.meters * 3.28)}))
            }
        },
        watch: {
            mountains(){
                this.isLoad = false
                let id = this.mountains.find(item => item.active).id
                this.updateData(id)
            },
        }
    }

</script>